

































import { Component, InjectReactive, Vue, Watch, Ref } from 'vue-property-decorator'
import Account from "../account"
import AccessToken from "../access-token"
import RestClient from "../components/RestClient.vue"
import InputDialog from "../components/InputDialog.vue"
import ConfirmDialog from "../components/ConfirmDialog.vue"
import Dashboard from './Dashboard.vue'

@Component({
    components: {
        InputDialog,
        ConfirmDialog,
    }
})
export default class VueComponent extends Vue {
    $log: any
    $parent!: Dashboard
    @Ref("inputDialog") readonly inputDialog!: InputDialog
    @Ref("confirmDialog") readonly confirmDialog!: ConfirmDialog
    get restClient() {
        return this.$parent.restClient
    }
    get account() {
        return this.$parent.account
    }
    get tokens(): AccessToken[] | undefined {
        return this.$parent.tokens
    }
    set tokens(v: AccessToken[] | undefined) {
        this.$parent.tokens = v
    }
    showCreateDialog() {
        var count = 0
        if (this.tokens) {
            count = this.tokens.length
        }
        this.inputDialog.show('新增金鑰', '金鑰'+(count+1), '例如: 我的金鑰',
                {text: '確定', action: () => { this.createAccessToken() }},
                {text: '取消', action: () => {}},
        )
    }
    showRenameDialog(token: AccessToken) {
        this.inputDialog.show('重新命名', token.name, '例如: 我的金鑰',
                {text: '確定', action: () => { this.renameAccessToken(token) }},
                {text: '取消', action: () => {}},
        )
    }
    showDeleteDialog(token: AccessToken) {
        this.confirmDialog.show(undefined, '確定要刪除金鑰 "' + token.name + '" 嗎?',
                {text: '確定', action: () => { this.deleteAccessToken(token) }},
                {text: '取消', action: () => {}},
        )
    }
    createAccessToken() {
        var req = {name: this.inputDialog.value, scope: 'elevation:read'}
        this.restClient.request('POST', '/v1/access_tokens', req, (data) => {
            let token = AccessToken.unmarshal(data)
            if (token) {
                if (this.tokens) {
                    this.tokens.push(token)
                } else {
                    this.tokens = [token]
                }
            }
        }, (uuid: string, s: JQueryAjaxSettings, xhr: JQueryXHR, status: string, ex: string): boolean => {
            if (xhr.status == 429) {
                this.confirmDialog.showMessage('已超過單一服務的金鑰數量上限')
                return true
            }
            return false
        })
    }
    renameAccessToken(token: AccessToken) {
        if (this.inputDialog.value) {
            var name = this.inputDialog.value
            var req = {id: token.id, name: name}
            this.restClient.request('PUT', '/v1/access_tokens', req, (data) => {
                token.name = name
            })
        }
    }
    deleteAccessToken(token: AccessToken) {
        this.restClient.request('DELETE', '/v1/access_tokens/' + decodeURIComponent(token.id), null, (data) => {
            if (this.tokens) {
                var index = this.tokens.indexOf(token)
                this.tokens.splice(index, 1)
            }
        })
    }
}
